module.exports = __webpack_public_path__ + "static/media/P01-SEG2014_Hu_BTFWI.7865dc36.pdf";